import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor( private navigation: NavigationService) { }

  ngOnInit() {
  }
  routeTo(path) {
    this.navigation.navigateTo(path);
    
}

}
